module.exports = {
  managedClient:  (Api) ->
    return Api.ManagedClient.query().$promise.then (managedClients) ->
      managedClients[0]

  workflowTemplate: ($stateParams, Api) ->
    if $stateParams.workflowId
      return Api.WorkflowTemplate.get(id: $stateParams.workflowId).$promise
    return new Api.WorkflowTemplate

  workflowStepConfigs: (Api) ->
    return Api.WorkflowStepConfig.query(archived: false).$promise

  workflowStepTemplates: ( $stateParams, WorkflowStepTemplates ) ->
    if $stateParams.workflowId
      return WorkflowStepTemplates.query( workflow_template: $stateParams.workflowId ).$promise
    else
      return WorkflowStepTemplates.decorate([])

  countries: (Api) ->
    return Api.Country.query().$promise

  loadTemplates: ( $templateCache ) ->
    $templateCache.put('fine-setup', require('./fine-setup.tpl.html'))
}
